import { render, staticRenderFns } from "./advertising.vue?vue&type=template&id=0ed97425&scoped=true"
import script from "./advertising.vue?vue&type=script&lang=js"
export * from "./advertising.vue?vue&type=script&lang=js"
import style0 from "./advertising.vue?vue&type=style&index=0&id=0ed97425&prod&lang=scss&scoped=true"
import style1 from "./advertising.vue?vue&type=style&index=1&id=0ed97425&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed97425",
  null
  
)

export default component.exports